import { SvgIcon } from '../SvgIcon';
import * as React from 'react';

interface IProps {
	className?: string;
	stroke?: string;
}

export const SupportIcon: React.FC<IProps> = ({ className, stroke = '#fff' }) => {
	return (
		<SvgIcon className={className} height={24} viewBox='0 0 24 24' width={24}>
			<g fill='none' stroke={stroke} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
				<path d='M4 17V12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12V17' />
				<path d='M20 17.5C20 18.88 18.88 20 17.5 20H17C15.9 20 15 19.1 15 18V15C15 13.9 15.9 13 17 13H20V17.5Z' />
				<path d='M4 17.5C4 18.88 5.12 20 6.5 20H7C8.1 20 9 19.1 9 18V15C9 13.9 8.1 13 7 13H4V17.5Z' />
				<path d='M17.5 20C17.5 20 17.5 22 14 22' />
				<circle cx='13' cy='22' r='1' fill={stroke} stroke='none' />
			</g>
		</SvgIcon>
	);
};
